import Cache from "../../../shared/store/cache";
import { ResultStatus, GST_API } from "../../../shared/types/enums";
import { SubscriptionArray, DataService } from "../../../shared/services/dataService";
import ApiService from "../../../shared/services/apiService";

export default class DocumentListService {
  // subscriptions
  static oSUBSCRIPTIONS = new SubscriptionArray();

  // cache
  static CACHE = new Cache(this.fetchFromApiObs);

  static getObs(_ignoreCache, context, _documentType) {
    if (_ignoreCache || this.CACHE.NOT_EXISTS()) {
      return this.fetchFromApiObs(context, _documentType);
    } else {
      return this.CACHE.getOBS();
    }
  }

  /**
   * Replace the static data inside of(...) with real ApiCall
   * @returns observable
   */
  static fetchFromApiObs(context, _documentType) {
    // clear the cache before returning the actual subscription
    this.CACHE.CLEAR();
    return ApiService.fetchHTTP_API(
      GST_API.Core,
      `/Document/GetDocuments/${context.user.tenantId}/${_documentType}/false`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  /** API Fetch */
  static fetchData(_component, _ignoreCache = false) {
    this.oSUBSCRIPTIONS.cancelAll();
    _component.setState({ fetchResult: ResultStatus.LOADING, data: [] });
    // save the subscription object
    this.oSUBSCRIPTIONS.add(
      this.getObs(_ignoreCache).subscribe(
        (o) => {
          // onResultStatus.SUCCESS
          if (!Array.isArray(o)) {
            o = new Array(o);
          }
          this.CACHE.SET(o);
          _component.setState({
            data: o,
            fetchResult: ResultStatus.SUCCESS,
          });
        },
        (o) => {
          // onResultStatus.ERROR
          _component.setState({
            fetchResult: ResultStatus.ERROR,
          });
        }
      )
    );
  }

  static getRows() {
    return [];
  }

  static dateFormatter(params) {
    return new Date(params.value).toLocaleDateString();
  }

  static getColumnDefs() {
    return [
      {
        headerName: "Document",
        field: "fileType",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        cellRenderer: "agGridDownloadFileViaImageCellRenderer",
        width: 100,
      },
      {
        headerName: "Document Name",
        field: "documentName",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        width: 200,
        cellRenderer: "childMessageRendererComponent",
      },
      {
        headerName: "Document Description",
        field: "documentDescription",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        width: 200,
      },
      {
        headerName: "File Name",
        field: "fileName",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        width: 200,
      },
      {
        headerName: "File Type",
        field: "fileType",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        width: 100,
      },
      {
        headerName: "Updated Date",
        field: "updatedDate",
        sortable: true,
        filter: "text",
        cellStyle: { "border-right": "1px solid lightgray" },
        resizable: true,
        width: 100,
        valueFormatter: (params) => {
          return DataService.formatDateString(params.data.updatedDate)
        }
      },
    ];
  }
}
